import { createReducer, on } from '@ngrx/store';
import * as fromPaymentRunSummaryActions from '../actions';
import { IPaymentRunSummary } from '../dto/pyament-run.dto';

export const paymentRunSummaryFeatureKey = 'paymentRunSummary';

export interface State {
  loadPaymentRunSummaryRequest: any;
  loadPaymentRunSummaryResponse: IPaymentRunSummary;
  loadPaymentRunSummaryFailure: Error | any;
  loaded: boolean;
}

export const initialState: State = {
  loaded: false,
  loadPaymentRunSummaryRequest: undefined,
  loadPaymentRunSummaryResponse: undefined,
  loadPaymentRunSummaryFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromPaymentRunSummaryActions.loadPaymentRunSummary, (state, action) => ({
    ...state,
    loadPaymentRunSummaryRequest: action.request
  })),
  on(fromPaymentRunSummaryActions.loadPaymentRunSummarySuccess, (state, action) => ({
    ...state,
    loadPaymentRunSummaryResponse: action.response,
    loaded: true
  })),
  on(fromPaymentRunSummaryActions.loadPaymentRunSummaryFailure, (state, action) => ({
    ...state,
    loadPaymentRunSummaryFailure: action.error
  }))
);

export const loadPaymentRunSummaryResponse = (state: State) => state.loadPaymentRunSummaryResponse;
export const loadPaymentRunSummaryFailure = (state: State) => state.loadPaymentRunSummaryFailure;
